import { useEffect, useCallback } from 'react';
import {
  createAlias,
  identifyUser,
  registerSuperProperties,
  setPeople,
  trackEvent as trackMixpanelEvent
} from 'utils/analytics';

export default (event, options = {}) => {
  const identify = uid => {
    identifyUser(uid);
  };

  const register = (...params) => {
    registerSuperProperties(...params);
  };

  const trackEvent = useCallback((event, options) => trackMixpanelEvent(event, options), []);

  useEffect(() => {
    event && trackEvent(event, options);
  }, [event, options, trackEvent]);

  return {
    trackEvent,
    createAlias,
    identify,
    setPeople,
    register
  };
};
